export function waitForFirstUserInteraction(callback: () => void): void {
  if (typeof window === "undefined") return;

  const trigger = () => {
    window.removeEventListener("click", trigger);
    window.removeEventListener("keydown", trigger);
    window.removeEventListener("scroll", trigger);
    window.removeEventListener("mousemove", trigger);
    callback();
  };

  window.addEventListener("click", trigger);
  window.addEventListener("keydown", trigger);
  window.addEventListener("scroll", trigger);
  window.addEventListener("mousemove", trigger);
}
